<template>
	<div class="flex justify-center flex-col">
		<div class="h-full">
			<svg
				width="48px"
				height="48px"
				xmlns="http://www.w3.org/2000/svg"
				xml:space="preserve"
				style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;"
			>
				<path
					transform="translate(0,16)"
					d="M15,17L20,17L18.595,15.595C18.214,15.214 18,14.697 18,14.158L18,11C18,8.463 16.392,6.187 14,5.341L14,5C14,3.903 13.097,3 12,3C10.903,3 10,3.903 10,5L10,5.341C7.67,6.165 6,8.388 6,11L6,14.159C6,14.697 5.786,15.214 5.405,15.595L4,17L9,17M15,17L15,18C15,19.646 13.646,21 12,21C10.354,21 9,19.646 9,18L9,17M15,17L9,17"
					style="fill:rgb(255,0,0);fill-opacity:0;fill-rule:nonzero;stroke:black;stroke-width:2px;"
				/>

				<g v-if="count" transform="translate(0,6)">
					<circle cx="24" cy="9" r="11" fill="red" />
					<text
						x="24px"
						y="13px"
						text-anchor="middle"
						style="font-family:'ArialMT', 'Arial', sans-serif;font-size:12px;fill:white;"
						font-weight="bold"
					>
						{{ getCount }}
					</text>
				</g>
			</svg>
		</div>
	</div>
</template>

<script>
export default {
	name: 'NotificationBell',
	props: {
		count: {},
	},
	computed: {
		getCount() {
			if (this.count >= 99) {
				return 99;
			}
			return this.count;
		},
	},
};
</script>

<style scoped></style>
